import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaSync, FaFilePdf, FaTimes } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import {Modal,ModalHeader,ModalBody,ModalFooter} from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import axios from 'axios';
import './Upcomingrenewals.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { v4 as uuidv4 } from 'uuid';

// ══════════════════════════════════════
//  CONSTANTS
// ══════════════════════════════════════
const API = 'https://digitalapi.definiteassurance.com/api';
const CERT_WEBHOOK = 'https://workflows.uuidesign.xyz/webhook/c924c7c4-d115-4724-a78c-27048b99b6f0';
const CERT_UAT_WEBHOOK = 'https://sms.definiteassurance.com/webhook/28cda5be-338d-4ab4-b705-08a313323192';
const PAYMENT_WEBHOOK = 'https://workflows.uuidesign.xyz/webhook/0623c8f7-d286-45c4-b823-2675d25de35a';
const WALLET_WEBHOOK = 'https://sms.definiteassurance.com/webhook/04a58cac-a6b4-4bde-883a-b364f32d9ae9';
const DOUBLE_INS_WEBHOOK = 'https://sms.definiteassurance.com/webhook/d6c9608b-cd90-481a-995d-d40c908c96db';
const COMPANY = 'Definite';
const STAMP_DUTY = 40;
const DOUBLE_INS_DEBOUNCE_MS = 800;
const ROWS_PER_PAGE = 20;

// ══════════════════════════════════════
//  HELPERS
// ══════════════════════════════════════
const formatISODate = (input) => {
  try {
    if (typeof input === 'string') return input.split('T')[0];
    if (input instanceof Date) return input.toISOString().split('T')[0];
    return '--';
  } catch { return '--'; }
};

const toTimestamp = (input) => {
  try {
    if (typeof input === 'string') return new Date(input).getTime();
    if (input instanceof Date) return input.getTime();
    return 0;
  } catch { return 0; }
};

/** Expiry urgency: days until expiry → CSS class */
const expiryClass = (dateStr) => {
  try {
    const days = Math.ceil((new Date(dateStr) - new Date()) / 86400000);
    if (days <= 7) return 'imminent';
    if (days <= 30) return 'soon';
    return 'normal';
  } catch { return 'normal'; }
};

/** Smart page-number array with ellipses */
const buildPageNumbers = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [1];
  const s = Math.max(2, current - 1);
  const e = Math.min(total - 1, current + 1);
  if (s > 2) pages.push('...');
  for (let i = s; i <= e; i++) pages.push(i);
  if (e < total - 1) pages.push('...');
  pages.push(total);
  return pages;
};

// ══════════════════════════════════════
//  COMPONENT
// ══════════════════════════════════════
export default function Upcomingrenewals() {
  const navigate = useNavigate();

  // ── Auth & agent ──
  const [credentials, setCredentials] = useState(null);
  const [isAuth, setIsauth] = useState(false);
  const [agent, setAgent] = useState('');
  const [agentCode, setAgentcode] = useState('');
  const [agentName, setAgentname] = useState('');

  // ── Data ──
  const [renewals, setRenewals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [exporting, setExporting] = useState(false);
  const [selectedProposal, setSelectedproposal] = useState(null);
  const [renewingOID, setRenewingOID] = useState(null);
  const [coverOption, setCoveroption] = useState(null);
  const [product, setProduct] = useState(null);
  const [capacity, setCapacity] = useState(null);
  const [tonnage, setTonnage] = useState(null);
  const [reg, setReg] = useState(null);
  const [commissionRate, setCommissionrate] = useState(null);
  const [basicPremium, setBasicpremium] = useState(null);
  const [commission, setCommission] = useState(null);
  const [netPremium, setNetpremium] = useState(null);
  const [whtax, setWhtax] = useState(null);
  const [grossPremium, setGrosspremium] = useState(null);
  const [phcf, setPhcf] = useState(null);
  const [trainingLevy, setTraininglevy] = useState(null);
  const [commencementDate, setCommencementdate] = useState(null);
  const [expiryDate, setExpirydate] = useState(null);
  const [modal, setModal] = useState(false);
    const [coption, setCoption] = useState(null);
  const [coverPeriod, setCoverperiod] = useState(null);
  const [commencementDateInput, setCommencementDateInput] = useState('');
  const [expiryDateAuto, setExpiryDateAuto] = useState('');
  const [sumInsured, setSuminsured] = useState(null);
  const [isPay, setIspay] = useState(false);
  const [paymentMode, setPaymentMode] = useState(0);
  const [walletBalance, setWalletBalance] = useState(null);
  const [prompt, setPrompt] = useState(false);
  const [payText, setPaytext] = useState('Send Request')
  const [isCert, setIsCert] = useState(0);
  const [isMpesa, setIsmpesa] = useState(true);
  const [payAmount, setPayamount] = useState(null);
  const [mpesaPhone, setMpesaphone] = useState(null);
  const [promptId, setPromptId] = useState(0);
  const [resendText, setResendtext] = useState('Resend Payment Request');
  const [certURL, setCertURL] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [retryText, setRetrytext] = useState('Retry');
  const [isCalculated, setIsCalculated] = useState(0);
  const [transactionId, setTransactionId] = useState(null);
  const [newProposalOID, setNewproposalOID] = useState(null);
  const [insuredOID, setInsuredoid] = useState(null);
  const [IOID, setIOID] = useState(null);
  const [paymentText, setPaymenttext] = useState('Prompt Now');
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [checkMpesa, setCheckMpesa] = useState(false);
  const [mpesaCode, setMpesaCode] = useState('');
  const [verifyText, setVerifyText] = useState('VERIFY');
  const [checkPayment, setCheckPayment] = useState('Checking payment please wait...');
  const [dsfApproved, setDsfApproved] = useState(0);
  const [parentIntermediary, setParentIntermediary] = useState(null);
  const [calculateText,setCalculatetext] = useState('Calculate Premium');


  const formatDateTime = (ms) => {
  const d = new Date(ms);
  const pad = (n, len = 2) => String(n).padStart(len, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(d.getMilliseconds(), 3)}`;
};
  const getNow = () => formatDateTime(Date.now());
  const [netCommission, setNetcommission] = useState(null);
  const [coverDays, setCoverdays] = useState(null);
  const [today] = useState(getNow());
  const [proceedText, setProceedtext] = useState('Proceed to Payment'); 
  const [errorCode, setErrorcode] = useState(null);




  const generateUniqueId = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
};
  const authHeaders = useCallback(() => {
    const base = { 'Content-Type': 'application/json' };
    return credentials ? { ...base, Authorization: `Basic ${credentials}` } : base;
  }, [credentials]);
  const insertLog = useCallback(
    async (agentId, activity) => {
      try {
        await fetch(`${API}/insertLogs?activity=${encodeURIComponent(activity)}&agent=${agentId}`, {
          headers: authHeaders(),
        });
      } catch (e) {
        console.error('Log insert failed', e);
      }
    },
    [authHeaders]
  );



  // ══════════════════════════════════════
  //  AUTH HEADERS
  // ══════════════════════════════════════


  // ══════════════════════════════════════
  //  INITIAL DATA FETCHING
  // ══════════════════════════════════════

  // Credentials
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/getCredentials?username=${COMPANY}`);
        const data = await res.json();
        setCredentials(btoa(`${data.Username}:${data.Password}`));
        setIsauth(true);
      } catch (e) {
        console.error('Failed to get credentials', e);
        toast.error('Authentication failed');
      }
    })();
  }, []);

  // Agent from localStorage
  useEffect(() => {
    const user = localStorage.getItem('definiteagent');
    if (user) setAgent(user);
    else navigate('/login');
  }, [navigate]);

  // Agent details
  useEffect(() => {
    if (!agent || !isAuth) return;
    (async () => {
      try {
        const res = await fetch(`${API}/getDealerdetails?email=${agent}`, {
          method: 'GET', headers: authHeaders()
        });
        const data = await res.json();
        setAgentcode(data.OID);
        setAgentname(data.Dealer_name || '');
        setDsfApproved(data.DSFAllowed);
        setParentIntermediary(data.ParentIntermediary);
      } catch (e) {
        console.error('getDealerdetails error', e);
      }
    })();
  }, [agent, isAuth, authHeaders]);

  // Fetch upcoming renewals
  useEffect(() => {
    if (!agentCode || !isAuth) return;
    setLoading(true);
    (async () => {
      try {
        const res = await fetch(`${API}/getUpcomingrenewals?agent=${agentCode}`, {
          method: 'GET', headers: authHeaders()
        });
        const data = await res.json();
        setRenewals(Array.isArray(data) ? data : []);


         const balRes = await fetch(`${API}/getWalletbalance?agent=${agentCode}`,{
           method: 'GET', headers: authHeaders()
         });

         const balData = await balRes.json();
          setWalletBalance(balData.Balance);


      } catch (e) {
        console.error('getUpcomingrenewals error', e);
        toast.error('Failed to load renewals');
        setRenewals([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [agentCode, isAuth, authHeaders]);

  // ══════════════════════════════════════
  //  FILTERED DATA (memoized — client-side)
  // ══════════════════════════════════════
  const filtered = useMemo(() => {
    let list = renewals;

    // Text search (client name, policy, registration, product)
    if (searchTerm.trim()) {
      const q = searchTerm.toLowerCase();
      list = list.filter(v =>
        (v.PolicyNo || '').toLowerCase().includes(q) ||
        (v.Dealer_name || '').toLowerCase().includes(q) ||
        (v.Narration || '').toLowerCase().includes(q) ||
        (v.ProductDescription || '').toLowerCase().includes(q) ||
        (v.Mobile || '').toLowerCase().includes(q)
      );
    }

    // Date range filter
    const startMs = startDate ? new Date(startDate).getTime() : 0;
    const endMs = endDate ? new Date(endDate).getTime() : 0;
    if (startMs && endMs) {
      list = list.filter(v => {
        const ts = toTimestamp(v.ExpiryDate);
        return ts >= startMs && ts <= endMs;
      });
    } else if (startMs) {
      list = list.filter(v => toTimestamp(v.ExpiryDate) >= startMs);
    }

    return list;
  }, [renewals, searchTerm, startDate, endDate]);

  // Reset page when filters change
  useEffect(() => { setCurrentPage(1); }, [searchTerm, startDate, endDate]);

  // Reset renewingOID when modal closes
  useEffect(() => {
    if (!modal) {
      setRenewingOID(null);
    }
  }, [modal]);

  // ══════════════════════════════════════
  //  PAGINATED DATA
  // ══════════════════════════════════════
  const totalPages = Math.ceil(filtered.length / ROWS_PER_PAGE);
  const indexOfFirst = (currentPage - 1) * ROWS_PER_PAGE;
  const indexOfLast = indexOfFirst + ROWS_PER_PAGE;
  const currentRows = filtered.slice(indexOfFirst, indexOfLast);
  const pageNumbers = useMemo(() => buildPageNumbers(currentPage, totalPages), [currentPage, totalPages]);

  // ══════════════════════════════════════
  //  PDF EXPORT (jspdf-autotable, no DOM mutation)
  // ══════════════════════════════════════
  const exportToPDF = useCallback(() => {
    if (filtered.length === 0) {
      toast.warn('No data to export');
      return;
    }
    setExporting(true);
    try {
      const pdf = new jsPDF('l', 'mm', 'a4'); // landscape for wide table
      pdf.setFontSize(16);
      pdf.setTextColor(26, 92, 90);
      pdf.text('Upcoming Renewals', 14, 16);
      pdf.setFontSize(9);
      pdf.setTextColor(100);
      pdf.text(`Generated: ${new Date().toLocaleDateString()} | Records: ${filtered.length}`, 14, 22);

      pdf.autoTable({
        startY: 28,
        head: [['#', 'Policy No.', 'Insured', 'Contact', 'Registration', 'Product', 'Expiry Date']],
        body: filtered.map((v, i) => [
          i + 1,
          v.PolicyNo || '--',
          v.Dealer_name || '--',
          v.Mobile || '--',
          v.Narration || '--',
          v.ProductDescription || '--',
          formatISODate(v.ExpiryDate),
        ]),
        styles: { fontSize: 8, cellPadding: 3 },
        headStyles: { fillColor: [26, 92, 90], textColor: 255, fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [245, 248, 247] },
      });

      pdf.save('upcoming_renewals.pdf');
      toast.success('PDF exported');
    } catch (e) {
      console.error('PDF export failed', e);
      toast.error('PDF export failed');
    } finally {
      setExporting(false);
    }
  }, [filtered]);

  const clearFilters = useCallback(() => {
    setSearchTerm('');
    setStartDate('');
    setEndDate('');
  }, []);

  const getCoverDetails =async(e)=>{
    try {
      const oid = String(e.target.value);
      setRenewingOID(oid);
      setSelectedproposal(oid);
      const res = await fetch(`${API}/getThisProposalRenewal?proposal=${oid}`, {
        method: 'GET', headers: authHeaders()
      });
      const data = await res.json();  
      const {ProductInsuredItem,CoverOption,Capacity,Tonnage,CommissionRate,Product,Narration,coption,SumInsured} = data
      setCoveroption(CoverOption);
      setCapacity(Capacity);
      setTonnage(Tonnage);
      setCommissionrate(CommissionRate);
      setProduct(Product);
      setReg(Narration);
      setCoption(coption);
      setSuminsured(SumInsured);  

      setModal(true);

        }
    catch (e) {
      console.error('getCoverdetails error', e);
      setRenewingOID(null);
    }
  }

  const calculatePremium=async()=>{
    try{
      setCalculatetext('Calculating...');
      const res = await fetch(`${API}/calculatePremium?product=${product}&coverOption=${coverOption}&capacity=${capacity}&tonnage=${tonnage}&sumInsured=${sumInsured}&coverPeriod=${coverPeriod}`, {
        method: 'GET',
        headers: authHeaders()
      });

      setCalculatetext('Calculate Premium');
      const data = await res.json();
      // Handle the response data


      const {premium} = data;
      setBasicpremium(premium);

      const ph = Math.round(premium * 0.002);
      setPhcf(ph);
      const tlevy = Math.round(premium * 0.0025);
      setTraininglevy(tlevy);
      const tp = premium + ph + tlevy;
      setGrosspremium(tp);
      setPayamount(tp);

      const comm = Math.round(tp * (commissionRate / 100));
      setCommission(comm);
      const net = tp - comm;
      setNetpremium(net);
      const wt = Math.round(comm * 0.01);
      setWhtax(wt);
      const nc = comm - wt;
      setNetcommission(nc);
   

    }
    catch(e){
      console.error('calculatePremium error', e);
    }
  }
                                // ── Calculate expiry date based on payment interval & commencement ──
  const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate();

  useEffect(() => {
    if (!coverPeriod || !commencementDateInput) {
      setExpiryDateAuto('');
      return;
    }
    // Parse the date string (format: "YYYY-MM-DD HH:mm:ss.SSS")
    const parts = commencementDateInput.split(' ')[0].split('-');
    const year = +parts[0];
    const month = +parts[1]; // 1-12
    const day = +parts[2];
    
    let daysToAdd = 0;
    switch (coverPeriod) {
      case 'Week':
        daysToAdd = 7;
        setCoverdays(7);
        break;
      case 'Fortnight':
        daysToAdd = 14;
        setCoverdays(14);
        break;
      case 'Monthly':
        daysToAdd = getDaysInMonth(year, month);
        setCoverdays(30);
        break;
      case '2installments':
      case '3Instalments':
      case '6Instalments':
      case '10Instalments':
        daysToAdd = 30;
        setCoverdays(30);
        break;
      case 'Annual':
      case 'Annually':
        daysToAdd = 365;
        setCoverdays(365);
        break;
      default:
        daysToAdd = 0;
    }
    if (daysToAdd > 0) {
      // Calculate expiry by adding days to a timestamp (avoids timezone issues)
      const startMs = new Date(year, month - 1, day).getTime();
      const expiryMs = startMs + (daysToAdd - 1) * 86400000; // subtract 1 day worth of ms
      const expiry = new Date(expiryMs);
      // Format: YYYY-MM-DD HH:mm:ss.SSS
      const pad = (n) => String(n).padStart(2, '0');
      const ms = String(expiry.getMilliseconds()).padStart(3, '0');
      const formatted = `${expiry.getFullYear()}-${pad(expiry.getMonth()+1)}-${pad(expiry.getDate())} ${pad(expiry.getHours())}:${pad(expiry.getMinutes())}:${pad(expiry.getSeconds())}.${ms}`;
      setExpiryDateAuto(formatted);
    }
  }, [coverPeriod, commencementDateInput]);

  // Reset date fields when modal closes
  useEffect(() => {
    if (!modal) {
      setCommencementDateInput('');
      setExpiryDateAuto('');
      setCoverperiod(null);
    }
  }, [modal]);

  const formatter = (amount) =>
  Number(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    const apiFetch = useCallback(
      async (url, options = {}) => {
        const res = await fetch(url, {
          method: 'GET',
          headers: authHeaders(),
          ...options,
        });
        if (!res.ok) throw new Error(`API ${res.status}: ${res.statusText}`);
        return res.json();
      },
      [authHeaders]
    );
    const buildCertPayload = useCallback(() => ({
        IOID, commencementUnix:commencementDateInput,expiryUnix:expiryDateAuto,capacity,tonnage,sumInsured
      }), [IOID, commencementDateInput, expiryDateAuto, capacity, tonnage, sumInsured]);
    

    const insertCertificate = useCallback(async (certLink, certNo) => {
      try {
        await fetch(`${API}/insertCertificate`, {
          method: 'POST',
          headers: authHeaders(),
          body: JSON.stringify({ proposalOID: newProposalOID, insuredOID, expiryUnix: expiryDateAuto, commencementUnix: commencementDateInput, certNo, certLink, today }),
        });
      } catch (e) { console.error('insertCertificate failed', e); }
    }, [authHeaders, newProposalOID, insuredOID, expiryDateAuto, commencementDateInput, today]);



  const insertCertificateError = useCallback(async (errorMes) => {
    try {
      await fetch(`${API}/insertCertificateerror`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ proposalOID: newProposalOID, insuredOID, expiryUnix: expiryDateAuto, commencementUnix: commencementDateInput, errorMes, today }),
      });
    } catch (e) { console.error('insertCertificateError failed', e); }
  }, [authHeaders, newProposalOID, insuredOID, expiryDateAuto, commencementDateInput, today]);



    const generateCert = async (statusSetter) => {

      setPaytext('Generating Certificate...');


       const res = await axios.post(CERT_WEBHOOK, buildCertPayload());
       //const res = await axios.post(CERT_UAT_WEBHOOK, buildCertPayload());
      if (res.data.success) {
        await insertCertificate(res.data.certURL, res.data.certNo);
        setCertURL(res.data.certURL);
        insertLog(agentCode, `Certificate for ${reg}(RENEWAL) generated`);
        setTimeout(() => setIsCert(1), 1500);
      } else {
        await insertCertificateError(res.data.errorMessage);
        insertLog(agentCode, `Certificate for ${reg}(RENEWAL) error-${res.data.errorMessage}`);
        setIsCert(2);
        setErrorcode(res.data.errorCode);
        setErrorMessage(res.data.errorMessage);
      }



    }



      const proposalBody = useCallback(() => ({
        commissionRate, agentCode, agentName, commencementUnix: commencementDateInput, expiryUnix: expiryDateAuto,
        today, coverDays, reg, product, payAmount, grossPremium, basicPremium, commission,
      phcf, trainingLevy, netCommission, netPremium,sumInsured, capacity, coverOptioncode: coverOption
       
      }), [commissionRate, agentCode, agentName,commencementDateInput, expiryDateAuto, today, coverDays, reg, product, payAmount, grossPremium, basicPremium, commission, phcf, trainingLevy, netCommission, netPremium,capacity,coverOption, sumInsured]);



  const checkAutoApprovalAndPay = async () => {
    try {
      const data = await apiFetch(`${API}/checkAutoApproval?proposal=${newProposalOID}&payAmount=${payAmount}`);
      if (data.autoApproved && data.paid) {
        setShowVerifyModal(false);
        setIsmpesa(false);
        toast.success('Payment received');
        insertLog(agentCode, `Proposal ${newProposalOID}(RENEWAL) approved`);
        await generateCert(setPaytext);
      } else if (!data.autoApproved && data.paid) {
        setShowVerifyModal(false);
        toast.success('Payment received');
        // Manual approval + cert
       const res2 = await fetch(`${API}/approveProposalRenewal`, {
            method: 'POST', headers: authHeaders(),
            body: JSON.stringify({ utilize: 0, ...proposalBody(), proposalOID:newProposalOID, transaction:transactionId }),
            credentials: 'include',
          });
    
        await generateCert(setPaytext);
      } else {
        setShowVerifyModal(true);
        setCheckMpesa(true);
      }
    } catch (e) { toast.error('Check failed'); console.error(e); }
  };


   const verifyMpesaCode = async () => {
      if (!mpesaCode) return;
      try {
        setVerifyText('Verifying...');
        const data = await apiFetch(`${API}/checkMpesa?code=${mpesaCode}&amount=${payAmount}&reg=${reg}`);
        if (data.success) {
          toast.success('Payment received');
          setShowVerifyModal(false);
          // Approve & generate
          const res2 = await fetch(`${API}/approveProposalRenewal`, {
            method: 'POST', headers: authHeaders(),
            body: JSON.stringify({ utilize: 0, ...proposalBody(), proposalOID:newProposalOID, transaction:mpesaCode }),
            credentials: 'include',
          });
    
      
          await generateCert(setPaytext);
        } else {
          toast.error('No transaction with that code');
        }
      } catch (e) { toast.error('Verification failed'); }
      finally { setVerifyText('VERIFY'); }
    };
  
    const retryCertificate = async () => {
      setRetrytext('Please wait...');
      await generateCert(setRetrytext);
      setRetrytext('RETRY');
    };
  

  const processPayment = async (statusSetter) => {
   
    if (paymentMode === 0) {
       const fmtPhone = '254' + mpesaPhone.slice(1);
      const ref = generateUniqueId();
      const uuid = uuidv4();
      const dateDone = getNow();

      // MPESA
      statusSetter('CHECKING PAYMENT...');
      setPaytext('Waiting for payment...');
      toast.success('Prompt sent to phone!');
      setPrompt(true);
  
        const res = await axios.post(PAYMENT_WEBHOOK, { formattedNumber2: fmtPhone, payAmount, reg, uuid, qref: `QP${ref}`, dateDone }, { timeout: 30000 });
        if (res.data.success) {
          setPaytext('Processing Certificate...');
          setTransactionId(res.data.transactionId);
          // insertLog(agentCode, `Payment Kes.${payAmount} for ${reg}(RENEWAL) received - ${res.data.transactionId}`);
          // Approve & generate cert
          const res2 = await fetch(`${API}/approveProposalRenewal`, {
            method: 'POST', headers: authHeaders(),
            body: JSON.stringify({ utilize: 0, ...proposalBody(), proposalOID:newProposalOID, transaction: res.data.transactionId }),
            credentials: 'include',
          });




         
          insertLog(agentCode, `Proposal ${newProposalOID}(RENEWAL) approved`);
          //check if certificate has generated.
          
          const checkRes = await apiFetch(`${API}/checkCert?proposalOID=${newProposalOID}`, { method: 'GET', headers: authHeaders() });
          const {CertificatePdf,success} = checkRes;
          if(success){
            setCertURL(CertificatePdf)
            insertLog(agentCode, `Certificate for ${newProposalOID} generated`);
            setTimeout(() => setIsCert(1), 1500);
          } else {
           await generateCert(statusSetter);
          }

          
        } else {
          setPromptId(1);
          toast.error('PAYMENT NOT RECEIVED');
          statusSetter('SEND REQUEST');
        }
      
    } else if (paymentMode === 1) {
      // WALLET
      if (payAmount > walletBalance) { toast.error('INSUFFICIENT WALLET BALANCE. TOP UP TO PROCEED'); return; }
      statusSetter('CHECKING WALLET...');

      try {
      
        const paywithwallet = await fetch(`${API}/renewProposalWithWallet`, {
          method: 'POST', headers: authHeaders(),
          body: JSON.stringify({ proposalOID: newProposalOID,DSFApproved: dsfApproved, parentIntermediary,today,agentCode}),
          credentials: 'include',
        });
        const payRes = await paywithwallet.json();
        if (!payRes.success) {
          toast.error('WALLET PAYMENT FAILED');
           insertLog(agentCode, `Payment for proposal ${newProposalOID}(Renewal) done by wallet failed.`);
          return;
        }
        else {
        
          insertLog(agentCode, `Payment for proposal ${newProposalOID}(Renewal) done by wallet and Approved`);
          await generateCert(statusSetter);

        }

       
      } catch (e) { toast.error('SOMETHING WENT WRONG'); statusSetter('SEND REQUEST'); }
    } 
  };



  



  const createRenewalProposal = async () => {

    try {
      setProceedtext('Processing...');
      const res = await fetch(`${API}/createProposalRenewal`, { 
     
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({ selectedProposal,product,coverOption,agentName,agentCode,commencementDate: commencementDateInput,expiryDate: expiryDateAuto,grossPremium,commission,netPremium,whtax,phcf: phcf,trainingLevy,netCommission,commissionRate,reg,sumInsured,coverPeriod,coverDays,today }),
        credentials: 'include',
      });
      const data = await res.json();  
      const {success, PolicyNo, proposalOID, insuredOID, IOID} = data;
      if(success){
        setProceedtext('Proceed to Payment');
        insertLog(agentCode, `Proposal ${proposalOID}(RENEWAL) created`);
        setNewproposalOID(proposalOID);
        setInsuredoid(insuredOID);
        setIOID(IOID);
        setIsCalculated(1);
      } else {
        setProceedtext('Proceed to Payment');
        toast.error('Failed to create proposal');
      }
    }
    catch (e) {
      console.error('createProposalRenewal error', e);
      toast.error('Failed to create proposal');
    } 
  }


    const finish = () => window.location.reload(false);
  // ══════════════════════════════════════
  //  RENDER
  // ══════════════════════════════════════
  return (
    <div className="renew-page">
      <Sidebar />
      <div className="renew-main">
        <Header userName={agentName || agent || 'Agent'} />
        <ToastContainer position="top-right" autoClose={4000} />

        {/* Top bar */}
        <div className="renew-top-row">
          <span className="renew-company">Definite Assurance</span>
          <span className="renew-breadcrumb">Dashboard / Renewals / Upcoming</span>
        </div>

        <div className="renew-card">
          <h3><FaSync style={{ marginRight: 8 }} /> Upcoming Renewals</h3>

          {/* Toolbar: search + dates + export */}
          <div className="renew-toolbar">
            <div className="renew-search-wrap">
              <FaSearch className="renew-search-icon" />
              <input
                type="text"
                placeholder="Search by policy, client, registration, product…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <div className="renew-date-group">
              <div className="renew-date-field">
                <label>From</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="renew-date-field">
                <label>To</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
              {(searchTerm || startDate || endDate) && (
                <button className="renew-clear-btn" onClick={clearFilters}>
                  <FaTimes style={{ marginRight: 4 }} /> Clear
                </button>
              )}
            </div>

            <button
              className="renew-export-btn"
              onClick={exportToPDF}
              disabled={exporting || filtered.length === 0}
            >
              <FaFilePdf />
              {exporting ? 'Exporting…' : 'Export PDF'}
            </button>

            <span className="renew-stat">
              Total: <strong>{renewals.length}</strong>
              {filtered.length !== renewals.length && (
                <> &nbsp;|&nbsp; Filtered: <strong>{filtered.length}</strong></>
              )}
            </span>
          </div>

          {/* Loading */}
          {loading && (
            <div className="renew-loading">
              <div className="renew-spinner" />
              <p>Loading renewals…</p>
            </div>
          )}

          {/* Empty state */}
          {!loading && filtered.length === 0 && (
            <div className="renew-empty">
              <FaSync size={32} color="#ccc" style={{ marginBottom: 10 }} />
              <p>{searchTerm || startDate || endDate ? 'No renewals match your filters.' : 'No upcoming renewals found.'}</p>
            </div>
          )}

          {/* Table */}
          {!loading && filtered.length > 0 && (
            <>
              <div className="renew-table-wrap">
                <table className="renew-table">
                  <thead>
                    <tr>
                      <th>#</th>
                     
                      <th>Insured</th>
                      <th>Contact</th>
                      <th>Registration</th>
                      <th>Product</th>
                      <th>Expiry Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRows.map((val, index) => (
                      <tr key={val.OID || index}>
                        <td>{indexOfFirst + index + 1}</td>
                       
                        <td>{val.Dealer_name}</td>
                        <td>{val.Mobile}</td>
                        <td>{val.Narration}</td>
                        <td>{val.ProductDescription}</td>
                        
                        <td>
                          <span className={`renew-expiry ${expiryClass(val.ExpiryDate)}`}>
                            {formatISODate(val.ExpiryDate)}
                          </span>
                        </td>
                        <td>
                        <button
                          className="renew-export-btn"
                          onClick={getCoverDetails}
                          value={val.OID}
                          disabled={renewingOID === String(val.OID)}
                        >
                         {renewingOID === String(val.OID) ? 'Processing...' : 'Renew Now'}
                        </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="renew-pagination">
                <span className="renew-pagination-info">
                  Showing {indexOfFirst + 1} to {Math.min(indexOfLast, filtered.length)} of {filtered.length} entries
                </span>
                <div className="renew-pagination-controls">
                  <button
                    className="renew-page-btn"
                    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  {pageNumbers.map((page, i) =>
                    page === '...'
                      ? <span key={`e${i}`} className="renew-page-ellipsis">…</span>
                      : (
                        <button
                          key={page}
                          className={`renew-page-btn ${currentPage === page ? 'active' : ''}`}
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      )
                  )}
                  <button
                    className="renew-page-btn"
                    onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages || totalPages === 0}
                  >
                    Next
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>


            <Modal isOpen={modal} toggle={()=>setModal(false)} size="xl" centered>
            <ModalHeader toggle={()=>setModal(false)} style={{ borderBottom: '2px solid #f0f0f0', padding: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ fontSize: '24px', color: '#2c3e50' }}>📋</div>
                <div>
                  <h5 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#2c3e50' }}>
                    {isCalculated === 0 ? 'Renew Policy' : 'Complete Payment'}
                  </h5>
                  <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#7f8c8d' }}>
                    {isCalculated === 0 ? 'Step 1: Set Dates & Premium' : 'Step 2: Payment Process'}
                  </p>
                </div>
              </div>
            </ModalHeader>
            <ModalBody style={{ padding: '48px' }}>
              <div className="renew-modal-form">
               
                {isCalculated === 0 && (
                  <>
                 
                    <div className="gc-steps" style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '40px', padding: '18px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                      <div className="gc-step active" style={{ textAlign: 'center', color: '#27ae60', fontWeight: 600 }}>
                        <span className="gc-step-number" style={{ display: 'block', width: '36px', height: '36px', lineHeight: '36px', borderRadius: '50%', backgroundColor: '#27ae60', color: 'white', margin: '0 auto 8px', fontWeight: 'bold' }}>1</span>
                        Dates &amp; Premium
                      </div>
                      <div className="gc-step" style={{ textAlign: 'center', color: '#95a5a6', fontWeight: 600 }}>
                        <span className="gc-step-number" style={{ display: 'block', width: '36px', height: '36px', lineHeight: '36px', borderRadius: '50%', backgroundColor: '#bdc3c7', color: 'white', margin: '0 auto 8px', fontWeight: 'bold' }}>2</span>
                        Payment
                      </div>
                    </div>

                    <div className="gc-form-section" style={{ padding: '24px', backgroundColor: '#ffffff', borderRadius: '8px', border: '1px solid #ecf0f1', marginBottom: '32px' }}>
                      <h4 style={{ margin: '0 0 24px 0', color: '#2c3e50', fontSize: '16px', fontWeight: 600 }}>📅 Policy Dates</h4>
                      <div className="gc-form-row" style={{ display: 'flex', flexDirection: 'column', gap: '24px', marginBottom: '24px' }}>
                        <div className="gc-form-group" style={{ minWidth: 0 }}>
                          <label style={{ display: 'block', marginBottom: '10px', fontWeight: 600, fontSize: '13px', color: '#2c3e50' }}>Payment Interval</label>
                          <select value={coverPeriod} onChange={(e) => setCoverperiod(e.target.value)} style={{ width: '100%', padding: '12px 14px', border: '1px solid #bdc3c7', borderRadius: '6px', fontSize: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', boxSizing: 'border-box' }}>
                            <option value="" disabled selected>Select Payment Interval</option>

                            {(product === 4638 || product === 3587) && (
                              <>
                                <option value="Week">7 Days</option>
                                <option value="Fortnight">14 Days</option>
                                <option value="Monthly">30 Days</option>
                                <option value="Annual">365 Days</option>
                                <option value="3Instalments">3 Instalments</option>
                                <option value="6Instalments">6 Instalments</option>
                                <option value="10Instalments">10 Instalments</option>
                              </>
                            )}

                            {product !== 4638 && product !== 3587 && coption===2 && (
                              <>
                                <option value="Annually">Annually</option>
                                <option value="2installments">2 Installments</option>
                              </>
                            )}
                            {product !== 4638 && product !== 3587 && (coption===1 || coption===58) && (
                              <>
                                <option value="Monthly">Monthly</option>
                              </>
                            )}

                          </select>
                        </div>

                        <div className="gc-form-group" style={{ minWidth: 0 }}>
                          <label style={{ display: 'block', marginBottom: '10px', fontWeight: 600, fontSize: '13px', color: '#2c3e50' }}>Commencement Date</label>
                          <input
                            type="date"
                            value={commencementDateInput ? commencementDateInput.split(' ')[0] : ''}
                            onChange={(e) => {
                              const dateStr = e.target.value;
                              setCommencementDateInput(dateStr + ' 00:00:00.000');
                            }}
                            min={new Date().toISOString().split('T')[0]}
                            style={{ width: '100%', padding: '12px 14px', border: '1px solid #bdc3c7', borderRadius: '6px', fontSize: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', boxSizing: 'border-box' }}
                          />
                        </div>
                      </div>

                      <div className="gc-form-row" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        <div className="gc-form-group" style={{ minWidth: 0 }}>
                          <label style={{ display: 'block', marginBottom: '10px', fontWeight: 600, fontSize: '13px', color: '#2c3e50' }}>Expiry Date</label>
                          <input
                            type="date"
                            value={expiryDateAuto ? expiryDateAuto.split(' ')[0] : ''}
                            disabled
                            style={{ width: '100%', padding: '12px 14px', border: '1px solid #ecf0f1', borderRadius: '6px', fontSize: '14px', backgroundColor: '#f8f9fa', color: '#95a5a6', boxSizing: 'border-box' }}
                          />
                        </div>
                      </div>
                    </div>

                    <hr style={{ borderColor: '#ecf0f1', margin: '32px 0' }} />

                    <button
                      className="gc-btn gc-btn-primary"
                      onClick={calculatePremium}
                      disabled={!coverPeriod || !commencementDateInput}
                      style={{ width: '100%', padding: '14px 16px', fontSize: '14px', fontWeight: 600, borderRadius: '6px', border: 'none', cursor: 'pointer', backgroundColor: (!coverPeriod || !commencementDateInput) ? '#a8d5ba' : '#27ae60', color: 'white', transition: 'all 0.3s', boxShadow: '0 2px 8px rgba(39, 174, 96, 0.2)' }}
                    >
                    💰 {calculateText}
                    </button>

                    {basicPremium !== null && (
                      <div className="renew-premium-summary" style={{ padding: '28px', backgroundColor: '#ecf7f2', borderRadius: '8px', border: '2px solid #27ae60', marginTop: '32px' }}>
                      
                        <hr style={{ borderColor: 'rgba(39, 174, 96, 0.2)', margin: '16px 0' }} />
                        <div className="gc-pay-amount" style={{ marginBottom: 0, textAlign: 'center' }}>
                          <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#7f8c8d', fontWeight: 500 }}>GROSS PREMIUM</p>
                          <h4 style={{ margin: 0, fontSize: '32px', color: '#27ae60', fontWeight: 700 }}>KES. {formatter(grossPremium)}</h4>
                        </div>

                        <button
                          className="gc-btn gc-btn-success"
                          style={{ marginTop: 20, width: '100%', padding: '16px 16px', fontSize: '15px', fontWeight: 600, borderRadius: '6px', border: 'none', cursor: 'pointer', backgroundColor: '#27ae60', color: 'white', transition: 'all 0.3s', boxShadow: '0 2px 8px rgba(39, 174, 96, 0.2)' }}
                          onClick={createRenewalProposal}
                        >
                          ✓ {proceedText} →
                        </button>
                      </div>
                    )}
                  </>
                )}
                {isCalculated === 1 && (
                  <>
                    <div className="gc-steps" style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '40px', padding: '18px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                      <div className="gc-step completed" style={{ textAlign: 'center', color: '#27ae60', fontWeight: 600 }}>
                        <span className="gc-step-number" style={{ display: 'block', width: '36px', height: '36px', lineHeight: '36px', borderRadius: '50%', backgroundColor: '#27ae60', color: 'white', margin: '0 auto 8px', fontWeight: 'bold' }}>✓</span> Dates &amp; Premium
                      </div>
                      <div className="gc-step active" style={{ textAlign: 'center', color: '#27ae60', fontWeight: 600 }}>
                        <span className="gc-step-number" style={{ display: 'block', width: '36px', height: '36px', lineHeight: '36px', borderRadius: '50%', backgroundColor: '#27ae60', color: 'white', margin: '0 auto 8px', fontWeight: 'bold' }}>2</span> Payment
                      </div>
                    </div>

                  

                    <div className="gc-modal-header" style={{ padding: '16px 0', borderBottom: '2px solid #ecf0f1', marginBottom: '24px' }}>
                      <h3 style={{ margin: '0 0 6px 0', fontSize: '18px', fontWeight: 600, color: '#2c3e50' }}>💳 Make Payment</h3>
                      <p style={{ margin: 0, fontSize: '13px', color: '#7f8c8d' }}>Proposal ID: <strong>{newProposalOID}</strong></p>
                    </div>
                    <div className="gc-modal-body" style={{ padding: '0' }}>
                      <div className="gc-form-group" style={{ marginBottom: 24 }}>
                        {/* <label style={{ fontWeight: 600, marginBottom: 12, display: 'block', textTransform: 'none', fontSize: '14px', color: '#2c3e50' }}>Payment Method</label>
                        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                          <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', borderRadius: '6px', border: isMpesa && paymentMode === 0 ? '2px solid #27ae60' : '2px solid #ecf0f1', backgroundColor: isMpesa && paymentMode === 0 ? '#ecf7f2' : '#fafafa', cursor: 'pointer', transition: 'all 0.3s', flex: '1' }}>
                            <input
                              type="radio"
                              name="paymentMethod"
                              checked={isMpesa && paymentMode === 0}
                              onChange={() => {
                                setIsmpesa(true);
                                setPaymentMode(0);
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                            <span style={{ fontWeight: 500, color: isMpesa && paymentMode === 0 ? '#27ae60' : '#2c3e50' }}>📱 Lipa na Mpesa</span>
                          </label>
                          <label style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', borderRadius: '6px', border: !isMpesa && paymentMode === 1 ? '2px solid #27ae60' : '2px solid #ecf0f1', backgroundColor: !isMpesa && paymentMode === 1 ? '#ecf7f2' : '#fafafa', cursor: 'pointer', transition: 'all 0.3s', flex: '1' }}>
                            <input
                              type="radio"
                              name="paymentMethod"
                              checked={!isMpesa && paymentMode === 1}
                              onChange={() => {
                                setIsmpesa(false);
                                setPaymentMode(1);
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                            <span style={{ fontWeight: 500, color: !isMpesa && paymentMode === 1 ? '#27ae60' : '#2c3e50' }}>💰 Wallet</span>
                          </label>
                        </div> */}
                      </div>

                      {isCert === 0 && (
                        <>
                          <div className="gc-pay-amount" style={{ padding: '20px', backgroundColor: '#fff3e0', borderRadius: '8px', border: '2px solid #f39c12', textAlign: 'center', marginBottom: 20 }}>
                            <p style={{ margin: '0 0 8px 0', fontSize: '13px', color: '#d68910', fontWeight: 500 }}>AMOUNT TO PAY</p>
                            <h4 style={{ margin: 0, fontSize: '28px', color: '#e67e22', fontWeight: 700 }}>KES. {formatter(payAmount)}</h4>
                          </div>
                          {isMpesa && (
                            <div className="gc-form-group" style={{ marginBottom: 20 }}>
                              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600, fontSize: '13px', color: '#2c3e50' }}>Mpesa Number *</label>
                              <input type="text" value={mpesaPhone} onChange={(e) => setMpesaphone(e.target.value)} placeholder="e.g. 0712345678" style={{ width: '100%', padding: '12px 14px', border: '1px solid #bdc3c7', borderRadius: '6px', fontSize: '14px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }} />
                            </div>
                          )}
                          {paymentMode === 1 && <p style={{ fontSize: '13px', color: '#27ae60', marginBottom: 16, padding: '12px', backgroundColor: '#ecf7f2', borderRadius: '6px' }}>💰 Available Balance: <strong>KES. {formatter(walletBalance)}</strong></p>}

                          {paymentMode === 0 && (
                            <>
                              {promptId === 0 && (
                                <button className="gc-btn gc-btn-success" style={{ width: '100%', marginBottom: 12, padding: '12px 16px', fontSize: '14px', fontWeight: 600, borderRadius: '6px', border: 'none', cursor: 'pointer', backgroundColor: '#27ae60', color: 'white' }} onClick={() => processPayment(setPaytext)} >
                                  📲 {payText}
                                </button>
                              )}
                              {promptId === 1 && (
                                <button className="gc-btn gc-btn-success" style={{ width: '100%', marginBottom: 12, padding: '12px 16px', fontSize: '14px', fontWeight: 600, borderRadius: '6px', border: 'none', cursor: 'pointer', backgroundColor: resendText !== 'RESEND REQUEST' ? '#95a5a6' : '#27ae60', color: 'white' }} onClick={() => processPayment(setResendtext)} disabled={resendText !== 'RESEND REQUEST'}>
                                  ⏱️ {resendText}
                                </button>
                              )}
                            </>
                          )}

                          {paymentMode === 1 && (
                            <>
                              {walletBalance < payAmount && <p style={{ color: '#e74c3c', marginBottom: 12, fontSize: '13px', padding: '10px 12px', backgroundColor: '#fadbd8', borderRadius: '6px' }}>⚠️ Insufficient wallet balance. Please top up to proceed.</p>}
                              {walletBalance >= payAmount && 
                                <button className="gc-btn gc-btn-success" style={{ width: '100%', marginBottom: 12, padding: '12px 16px', fontSize: '14px', fontWeight: 600, borderRadius: '6px', border: 'none', cursor: 'pointer', backgroundColor: '#27ae60', color: 'white' }} onClick={() => processPayment(setPaytext)} >
                                  💳 {payText}
                                </button>
                              }
                            </>
                          )}

                          {isMpesa && !prompt && (
                            <>
                              <div className="gc-separator" style={{ textAlign: 'center', margin: '20px 0', color: '#bdc3c7', fontSize: '12px', fontWeight: 500 }}>────── OR ──────</div>
                              <div className="gc-mpesa-steps" style={{ padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #ecf0f1' }}>
                                <p style={{ margin: '0 0 10px 0', fontSize: '13px', fontWeight: 600, color: '#2c3e50' }}>📱 Manual MPESA Payment:</p>
                                <ol style={{ margin: '8px 0', paddingLeft: '20px', lineHeight: '1.8' }}>
                                  <li style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>Go to MPESA Toolkit</li>
                                  <li style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>Select Lipa na Mpesa</li>
                                  <li style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>Select Paybill</li>
                                  <li style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>Paybill: <strong style={{ color: '#27ae60' }}>200300</strong></li>
                                  <li style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>Account: <strong style={{ color: '#27ae60' }}>{reg}</strong></li>
                                  <li style={{ fontSize: '12px', color: '#555', marginBottom: '6px' }}>Amount: <strong style={{ color: '#27ae60' }}>KES. {payAmount}</strong></li>
                                  <li style={{ fontSize: '12px', color: '#555' }}>Enter PIN and Complete</li>
                                </ol>
                                 <button className="gc-already-paid" onClick={checkAutoApprovalAndPay} style={{ width: '100%', marginTop: '12px', padding: '10px 12px', backgroundColor: '#ecf0f1', border: '1px solid #bdc3c7', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: 600, color: '#27ae60' }}>✓ Already paid? Click here</button>
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {isCert === 1 && (
                        <div className="gc-cert-success" style={{ textAlign: 'center', padding: '32px 16px', backgroundColor: '#ecf7f2', borderRadius: '8px', border: '2px solid #27ae60' }}>
                          <h3 style={{ margin: '0 0 16px 0', color: '#27ae60', fontSize: '18px' }}>✅ Certificate Generated!</h3>
                          <a href={certURL} target="_blank" rel="noreferrer" style={{ display: 'inline-block', padding: '14px 24px', backgroundColor: '#27ae60', color: 'white', textDecoration: 'none', borderRadius: '6px', fontWeight: 600, marginBottom: '12px', transition: 'all 0.3s' }}>📥 DOWNLOAD CERTIFICATE</a>
                          <p style={{ fontSize: '12px', color: '#666', margin: '12px 0 0 0' }}>If certificate does not download, click the button again.</p>
                          <button className="gc-btn gc-btn-success" style={{ marginTop: 16 }} onClick={finish}>FINISH</button>
                        </div>
                      )}

                      {isCert === 2 && (
                        <div className="gc-cert-error">
                          <p>ERROR: {errorMessage}</p>
                          <button className="gc-btn gc-btn-success" onClick={retryCertificate}>{retryText}</button>
                          <br /><br />
                         <button className="gc-btn gc-btn-success" style={{ marginTop: 16 }} onClick={finish}>FINISH</button>
                        </div>
                      )}

                      {isCert === 0 && (
                        <div className="gc-dmvic-errors">
                          <h6>Common DMVIC Errors</h6>
                          <p className="gc-error-title">Please note that the details entered do not match NTSA records</p>
                          <p className="gc-error-desc">The portal will generate certificate and send to your email despite this error. If not, navigate to 'Failed Certificates', search and click 'Retry'.</p>
                          <p className="gc-error-title">Invalid insured pin</p>
                          <p className="gc-error-desc">Navigate to 'Failed Certificates', click 'Edit', change KRA Pin, 'Save changes' and 'Retry'.</p>
                          <p className="gc-error-title">Invalid insured email</p>
                          <p className="gc-error-desc">Navigate to 'Failed Certificates', click 'Edit', change email, 'Save changes' and 'Retry'.</p>
                        </div>
                      )}
                    </div>

                    <div className="gc-btn-row">
                      <button
                        className="gc-btn gc-btn-outline"
                        onClick={() => setIsCalculated(0)}
                      >
                        ← Back to Step 1
                      </button>
                    </div>
                  </>
                )}

                 {showVerifyModal && (
                          <div className="gc-modal-overlay">
                            <div className="gc-modal" onClick={(e) => e.stopPropagation()}>
                              <div className="gc-modal-header">
                                <h3>Confirm Payment</h3>
                                <button className="gc-modal-close" onClick={() => { setShowVerifyModal(false); setCheckMpesa(false); }}><FaTimes /></button>
                              </div>
                              <div className="gc-modal-body">
                                {!checkMpesa && <p style={{ textAlign: 'center' }}>{checkPayment}</p>}
                                {checkMpesa && (
                                  <>
                                    <p style={{ color: '#c0392b', marginBottom: 12 }}>Enter the M-Pesa transaction code below</p>
                                    <div className="gc-form-group" style={{ marginBottom: 14 }}>
                                      <label>Transaction Code</label>
                                      <input type="text" value={mpesaCode} onChange={(e) => setMpesaCode(e.target.value)} placeholder="e.g. SBK1234ABC" />
                                    </div>
                                    <button className="gc-btn gc-btn-success" style={{ width: '100%' }} onClick={verifyMpesaCode} disabled={verifyText !== 'VERIFY'}>
                                      {verifyText}
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
              </div>
            </ModalBody>
          </Modal>
      
    </div>
  );
}
